import React, {
	memo,
	useEffect, useRef, useState,
} from 'react';
import ReactDOM from 'react-dom';

interface SpotlightProps {
    spotlightId: string;
	mediaId: number | string;
	position: number | string;
	isAudioOnly: boolean;
	nextShot?: boolean;
}

const Spotlight: React.FC<SpotlightProps> = ({
	spotlightId, mediaId, position, isAudioOnly, nextShot,
}) => {
	const myRef = useRef<HTMLDivElement | null>(null);
	const [unmanagedDiv, setUnmanagedDiv] = useState<HTMLDivElement | null>(null);
	const [allContainers, setAllContainers] = useState<{ [key: string]: Element }>({});

	useEffect(() => {
		const containers = document.querySelectorAll('.spotlight-container');
		containers.forEach((container) => {
			allContainers[container.id] = container;
			setAllContainers(allContainers);
		});
	}, []);

	const hiddenSlotId = `${nextShot ? '-hidden-spotlight-' : ''}`;
	const containerID = `${position}${hiddenSlotId}${isAudioOnly ? 'audio-only' : ''}`;

	useEffect(() => {
		const divExists = document.getElementById(spotlightId);
		let createdDiv: HTMLDivElement;
		if (divExists) {
			createdDiv = divExists as HTMLDivElement;
		} else {
			createdDiv = document.createElement('div');
			createdDiv.className = 'spotlight';
			createdDiv.id = spotlightId;
		}

		setUnmanagedDiv(createdDiv);
		return () => {
			// Clean up the DOM element
			createdDiv.remove();
		};
	}, []);

	useEffect(() => {
		if (myRef.current && unmanagedDiv) {
			myRef.current.appendChild(unmanagedDiv);
		}
	}, [myRef.current, unmanagedDiv, containerID]);

	return (allContainers[containerID]
        && <>
            { ReactDOM.createPortal(<div key={`spotlight-holder-${spotlightId}`} id={`spotlight-holder-${spotlightId}`} className='spotlight' ref={myRef}></div>, allContainers[containerID])
            }
        </>
	);
};

export default memo(Spotlight);
